import styled from 'styled-components'

export const Wrapper = styled.div<{ $isLoading: boolean }>(({ theme, $isLoading }) => ({
  background: theme.colors.white,
  borderRadius: theme.border.radius['6'],
  boxShadow: '0px 0px 8.5px rgba(120, 79, 12, 0.06)',
  opacity: $isLoading ? 0.5 : 1,
  padding: theme.space['20'],
  pointerEvents: $isLoading ? 'none' : 'auto',
  transition: `opacity ${theme.transition.duration.sm} ease`,
}))

export const Row = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['32'],
}))

export const MetricsBox = styled.div(({ theme }) => ({
  alignItems: 'center',
  border: `${theme.border.size['1']} solid ${theme.colors.gray300}`,
  borderRadius: theme.border.radius['4'],
  display: 'flex',
  flex: 1,
  gap: theme.space['16'],
  height: '7.4rem',
  padding: `${theme.space['12']} ${theme.space['16']}`,
}))

export const MetricItem = styled.div(({ theme }) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  gap: theme.space['2'],
}))

export const MetricLabelRow = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['4'],
}))

export const MetricDivider = styled.div(({ theme }) => ({
  alignSelf: 'stretch',
  background: theme.colors.gray300,
  flexShrink: 0,
  width: '0.1rem',
}))

export const PeriodWrapper = styled.div(() => ({
  flexShrink: 0,
  width: 'fit-content',
}))
